import { Client } from '@microsoft/microsoft-graph-client'
const mockUserPhoto = 'https://cdn.vuetifyjs.com/images/lists/5.jpg'
export async function getUserProfile (accessToken) {
  if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
    // return a mock user object
    return {
      displayName: 'Jane Doe',
      mail: 'jane.doe@lilly.com',
      jobTitle: 'Software Developer',
      givenName: 'Jane',
      surname: 'Doe',
      initials: 'JD',
      isAdmin: true
    }
  } else {
    const client = Client.init({
      authProvider: (done) => {
        done(null, accessToken)
      }
    })

    try {
      const user = await client
        .api('/me')
        .select('displayName,mail,jobTitle,givenName,surname')
        .get()
      // console.log('user:',user);
      // set user.initials by taking the first letter of the givenName and surname
      user.initials = (user.givenName ? user.givenName.charAt(0) : '') + (user.surname
        ? user.surname.charAt(0)
        : '')

      const adminGroupId = process.env.VUE_APP_DEVELOPER_DL.split('@')[0]
      const isAdmin = await checkMemberGroups(accessToken, [`${adminGroupId}`])
      user.isAdmin = isAdmin
      return user
    } catch (error) {
      console.error('Error fetching user profile:', error)
      return null
    }
  }
}

export async function getUserPhoto (accessToken) {
  if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
    return mockUserPhoto
  } else {
    const client = Client.init({
      authProvider: (done) => {
        done(null, accessToken)
      }
    })

    try {
      const photo = await client
        .api('/me/photo/$value')
        .responseType('blob')
        .get()
      return URL.createObjectURL(photo)
    } catch (error) {
      console.error('Error fetching user photo:', error)
      return null
    }
  }
}
export async function getPeoplePhoto (accessToken, email) {
  if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
    return mockUserPhoto
  } else {
    const client = Client.init({
      authProvider: (done) => {
        done(null, accessToken)
      }
    })

    try {
      const photo = await client
        .api(`/users/${email}/photo/$value`)
        .responseType('blob')
        .get()
      return URL.createObjectURL(photo)
    } catch (error) {
      console.error('Error fetching user photo:', error)
      return null
    }
  }
}
// // write a function to check if logged user belongs to an AD group using Microsoft Graph API
// export async function checkMemberGroups (accessToken, groupIds) {
//   const client = Client.init({
//     authProvider: (done) => {
//       done(null, accessToken)
//     }
//   })

//   try {

//     const res = await client
//       .api('/me/checkMemberGroups')
//       .post({ groupIds: groupIds })
//     console.log('checkMemberGroups:', res)
//     return res.value
//   } catch (error) {
//     console.error('Error checking group membership:', error)
//     return []
//   }
// }

// write a function to get list of groups logged user belongs to using Microsoft Graph API and check if user belongs to given group and return isAdmin true if so.
export async function checkMemberGroups (accessToken, groupName) {
  const client = Client.init({
    authProvider: (done) => {
      done(null, accessToken)
    }
  })

  try {
    const res = await client
      .api(`/me/memberOf/microsoft.graph.group?$search="displayName:${groupName}"&$select=id`)
      .header('ConsistencyLevel', 'eventual')
      .get()
    const groupIdsUserBelongsTo = res.value.map(group => group.id)
    const isAdmin = groupIdsUserBelongsTo.length > 0
    return isAdmin
  } catch (error) {
    console.error('Error checking group membership:', error)
    return false
  }
}

// write a function to get the group id of the group name using Microsoft Graph API
export async function getGroupId (accessToken, groupName) {
  const client = Client.init({
    authProvider: (done) => {
      done(null, accessToken)
    }
  })

  try {
    const res = await client
      .api('/groups')
      .filter(`displayName eq '${groupName}'`)
      .get()
    // console.log('getGroupId:', res)
    return res.value[0].id
  } catch (error) {
    console.error('Error getting group id:', error)
    return null
  }
}
